module.exports = __webpack_public_path__ + "fonts/Hijrnotes_PERSONAL_USE_ONLY.f30ff0f1.ttf";